export default __webpack_public_path__ + "static/media/search.ce8a489c.svg";